import BotAvatar from '../BotAvatar/BotAvatar';

/**
 * Chip de bot: avatar circular + username.
 * Cai no fallback BotIcon quando photoUrl não está disponível.
 * Estilos em public/css/list/list.css (.sx-botchip).
 */
export default function BotChip({ photoUrl, label, size = 18, textSize = 12 }) {
  return (
    <span className="sx-botchip" title={label}>
      <BotAvatar photoUrl={photoUrl} size={size} />
      <span className={`text-${textSize === 12 ? 'xs' : 'sm'}`}>{label}</span>
    </span>
  );
}
